export default __webpack_public_path__ + "static/media/img008.2aea4420.png";